export default __webpack_public_path__ + "static/media/costa-rica.dbb9a7af.svg";